// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__3ztcu","errorLogs":"styles_errorLogs__182Ea"};